import { Container, Row, Col } from "react-bootstrap";

export const Contacts = () => {
  return (
    <Container className="contacts py-3" fluid>
      <Row className="mb-3">
        <h4>Contact us</h4>
      </Row>
      <Row className="mb-3">
        <Col>
          <p>Purchases of seconds are no longer available.</p>
          <p>
            You can still use your remaining seconds. To request a partial refund, contact client support below.
          </p>
        </Col>
      </Row>
      <Row className="links mb-3">
        <Col>
          Client support:
          <br />
          <a href="mailto:support@wannafake.com">support@wannafake.com</a>
        </Col>
      </Row>
    </Container>
  );
};
